export const contactData = [
  {
    type: "phone",
    icon: "fas fa-phone",
    title: "Phone Number",
    link: "tel:+917426999648",
    text: "7426-999-648",
  },
  {
    type: "email",
    icon: "fa fa-envelope",
    title: "Email Address",
    link: "mailto:namocars16@gmail.com",
    text: "namocars16@gmail.com",
  },
  {
    type: "location",
    icon: "fa fa-map-marker",
    title: "Location",
    link: "https://maps.app.goo.gl/Li9uq3AXVwCgYPr5A",
    text: "207, 2nd Floor Manokamna Complex Near Sbi Bank Sector 11, Udaipur",
  },
  {
    type: "hours",
    icon: "fa fa-clock",
    title: "Opening Hours",
    link: "https://maps.app.goo.gl/Li9uq3AXVwCgYPr5A",
    text: "Mon - Sat (7 AM - 11 PM)",
  },
];
